/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import {useIntl} from 'react-intl'
import {KTIcon} from '../../../../helpers'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const ROLE_ADMIN = parseInt(process.env.REACT_APP_ROLE_ADMIN + '')
  const ROLE_MANAGER = parseInt(process.env.REACT_APP_ROLE_MANAGER + '')
  const ROLE_EMPLOYEE = parseInt(process.env.REACT_APP_ROLE_EMPLOYEE + '')
  const intl = useIntl()
  const {checkAuthorization} = useAuth()
/*
    <!--
      <SidebarMenuItem
        to='/dashboard'
        icon='element-11'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
      />
      -->
      */
  return (
    <>


{     checkAuthorization([ROLE_ADMIN]) && (
        <SidebarMenuItem to='/tenants' title='Tenant' icon='abstract-26' />
      )}
      {checkAuthorization([ROLE_ADMIN]) && (
        <SidebarMenuItem to='/user' icon='people' title='Utenti' />
      )}

      {checkAuthorization([ROLE_ADMIN]) && (
        <SidebarMenuItem to='/extractors' title='Estrattori' icon='abstract-1' />
      )}

      {checkAuthorization([ROLE_ADMIN]) && (
        <SidebarMenuItem to='/licences' title='Licenze' icon='badge' />
      )}
    </>
  )
}

export {SidebarMenuMain}
